import rootApi from '@utils/baseAPI/WrapperApi';

export const signIn = (username, password) => {
  return rootApi.post('/auth/login', {
    userName: username,
    password: password
  });
};

export const getToken = (apiKey) => {
  return rootApi.post('/auth/getToken', {
    apiKey
  });
};

export const resetPassword = (username) => {
  return rootApi.post('/users/reset/password', { username: username });
};

export const Registered = (data) => {
  return rootApi.post('/auth/register', data);
};
